const cryptoAdoptionIndexData = [
  {
    "rank": 1,
    "iso": "SG",
    "country": "Singapore",
    "publicAdoption": 7.1,
    "infrastructureAdoption": 6.4,
    "innovationAndTechnology": 9.3,
    "regulatoryEnvironment": 8.5,
    "economicFactors": 8.9,
    "taxFriendliness": 10,
    "total": 50.2,
    "totalPercentage": 0.8367
  },
  {
    "rank": 2,
    "iso": "CH",
    "country": "Switzerland",
    "publicAdoption": 3.9,
    "infrastructureAdoption": 9.2,
    "innovationAndTechnology": 8.7,
    "regulatoryEnvironment": 8.4,
    "economicFactors": 8.6,
    "taxFriendliness": 8.1,
    "total": 46.9,
    "totalPercentage": 0.7817
  },
  {
    "rank": 3,
    "iso": "AE",
    "country": "UAE",
    "publicAdoption": 7.1,
    "infrastructureAdoption": 5.9,
    "innovationAndTechnology": 8.7,
    "regulatoryEnvironment": 5.6,
    "economicFactors": 8.4,
    "taxFriendliness": 10,
    "total": 45.7,
    "totalPercentage": 0.7617
  },
  {
    "rank": 4,
    "iso": "HK",
    "country": "Hong Kong",
    "publicAdoption": 4.6,
    "infrastructureAdoption": 7.5,
    "innovationAndTechnology": 8.7,
    "regulatoryEnvironment": 6.7,
    "economicFactors": 9.1,
    "taxFriendliness": 9,
    "total": 45.6,
    "totalPercentage": 0.76
  },
  {
    "rank": 5,
    "iso": "US",
    "country": "USA",
    "publicAdoption": 6.3,
    "infrastructureAdoption": 9.6,
    "innovationAndTechnology": 6.7,
    "regulatoryEnvironment": 7.7,
    "economicFactors": 8.2,
    "taxFriendliness": 5.8,
    "total": 44.3,
    "totalPercentage": 0.7383
  },
  {
    "rank": 6,
    "iso": "AU",
    "country": "Australia",
    "publicAdoption": 5.1,
    "infrastructureAdoption": 9.2,
    "innovationAndTechnology": 8.7,
    "regulatoryEnvironment": 8,
    "economicFactors": 8,
    "taxFriendliness": 4.1,
    "total": 43.1,
    "totalPercentage": 0.7183
  },
  {
    "rank": 7,
    "iso": "GB",
    "country": "UK",
    "publicAdoption": 5.5,
    "infrastructureAdoption": 7.7,
    "innovationAndTechnology": 10,
    "regulatoryEnvironment": 6.4,
    "economicFactors": 7.6,
    "taxFriendliness": 5.5,
    "total": 42.7,
    "totalPercentage": 0.7117
  },
  {
    "rank": 8,
    "iso": "CA",
    "country": "Canada",
    "publicAdoption": 5.1,
    "infrastructureAdoption": 9.3,
    "innovationAndTechnology": 5.3,
    "regulatoryEnvironment": 7.4,
    "economicFactors": 8.1,
    "taxFriendliness": 5.2,
    "total": 40.4,
    "totalPercentage": 0.6733
  },
  {
    "rank": 9,
    "iso": "MT",
    "country": "Malta",
    "publicAdoption": 3.6,
    "infrastructureAdoption": 5.4,
    "innovationAndTechnology": 8,
    "regulatoryEnvironment": 6.6,
    "economicFactors": 7.5,
    "taxFriendliness": 7.8,
    "total": 38.9,
    "totalPercentage": 0.6483
  },
  {
    "rank": 10,
    "iso": "MY",
    "country": "Malaysia",
    "publicAdoption": 2.6,
    "infrastructureAdoption": 4.8,
    "innovationAndTechnology": 8,
    "regulatoryEnvironment": 6.4,
    "economicFactors": 7.6,
    "taxFriendliness": 8.1,
    "total": 37.5,
    "totalPercentage": 0.625
  },
  {
    "rank": 11,
    "iso": "TH",
    "country": "Thailand",
    "publicAdoption": 2.7,
    "infrastructureAdoption": 7.5,
    "innovationAndTechnology": 6,
    "regulatoryEnvironment": 6.3,
    "economicFactors": 8.1,
    "taxFriendliness": 6.4,
    "total": 37,
    "totalPercentage": 0.6167
  },
  {
    "rank": 12,
    "iso": "NL",
    "country": "Netherlands",
    "publicAdoption": 2.4,
    "infrastructureAdoption": 3.8,
    "innovationAndTechnology": 7.3,
    "regulatoryEnvironment": 7.3,
    "economicFactors": 8.1,
    "taxFriendliness": 7.4,
    "total": 36.3,
    "totalPercentage": 0.605
  },
  {
    "rank": 13,
    "iso": "IT",
    "country": "Italy",
    "publicAdoption": 0.7,
    "infrastructureAdoption": 7.3,
    "innovationAndTechnology": 8,
    "regulatoryEnvironment": 6.5,
    "economicFactors": 7.4,
    "taxFriendliness": 4.9,
    "total": 34.8,
    "totalPercentage": 0.58
  },
  {
    "rank": 14,
    "iso": "AG",
    "country": "Antigua and Barbuda",
    "publicAdoption": 3.1,
    "infrastructureAdoption": 2.8,
    "innovationAndTechnology": 6.7,
    "regulatoryEnvironment": 7.4,
    "economicFactors": 6.3,
    "taxFriendliness": 8.4,
    "total": 34.7,
    "totalPercentage": 0.5783
  },
  {
    "rank": 15,
    "iso": "AT",
    "country": "Austria",
    "publicAdoption": 1.7,
    "infrastructureAdoption": 5.4,
    "innovationAndTechnology": 7.3,
    "regulatoryEnvironment": 5.3,
    "economicFactors": 8,
    "taxFriendliness": 6.6,
    "total": 34.3,
    "totalPercentage": 0.5717
  },
  {
    "rank": 16,
    "iso": "NZ",
    "country": "New Zealand",
    "publicAdoption": 2.4,
    "infrastructureAdoption": 7.4,
    "innovationAndTechnology": 4.7,
    "regulatoryEnvironment": 3.8,
    "economicFactors": 8.4,
    "taxFriendliness": 7.5,
    "total": 34.2,
    "totalPercentage": 0.57
  },
  {
    "rank": 17,
    "iso": "MC",
    "country": "Monaco",
    "publicAdoption": 0.3,
    "infrastructureAdoption": 7.5,
    "innovationAndTechnology": 3.3,
    "regulatoryEnvironment": 5.2,
    "economicFactors": 7.5,
    "taxFriendliness": 9.2,
    "total": 33,
    "totalPercentage": 0.55
  },
  {
    "rank": 18,
    "iso": "PT",
    "country": "Portugal",
    "publicAdoption": 2.3,
    "infrastructureAdoption": 6.3,
    "innovationAndTechnology": 4.7,
    "regulatoryEnvironment": 4.9,
    "economicFactors": 7,
    "taxFriendliness": 6.7,
    "total": 31.9,
    "totalPercentage": 0.5317
  },
  {
    "rank": 19,
    "iso": "CY",
    "country": "Cyprus",
    "publicAdoption": 2.6,
    "infrastructureAdoption": 3.5,
    "innovationAndTechnology": 4.7,
    "regulatoryEnvironment": 6.4,
    "economicFactors": 6.6,
    "taxFriendliness": 7.8,
    "total": 31.6,
    "totalPercentage": 0.5267
  },
  {
    "rank": 20,
    "iso": "MU",
    "country": "Mauritius",
    "publicAdoption": 4.7,
    "infrastructureAdoption": 4.3,
    "innovationAndTechnology": 0.7,
    "regulatoryEnvironment": 6.3,
    "economicFactors": 5.8,
    "taxFriendliness": 9.1,
    "total": 30.9,
    "totalPercentage": 0.515
  },
  {
    "rank": 21,
    "iso": "LU",
    "country": "Luxembourg",
    "publicAdoption": 1.6,
    "infrastructureAdoption": 3.1,
    "innovationAndTechnology": 7.3,
    "regulatoryEnvironment": 6.9,
    "economicFactors": 8.3,
    "taxFriendliness": 3.6,
    "total": 30.8,
    "totalPercentage": 0.5133
  },
  {
    "rank": 22,
    "iso": "KN",
    "country": "St. Kitts and Nevis",
    "publicAdoption": 2.2,
    "infrastructureAdoption": 5.1,
    "innovationAndTechnology": 4,
    "regulatoryEnvironment": 5,
    "economicFactors": 5.3,
    "taxFriendliness": 8.3,
    "total": 29.9,
    "totalPercentage": 0.4983
  },
  {
    "rank": 23,
    "iso": "GR",
    "country": "Greece",
    "publicAdoption": 1,
    "infrastructureAdoption": 7.5,
    "innovationAndTechnology": 7.3,
    "regulatoryEnvironment": 4.1,
    "economicFactors": 6.3,
    "taxFriendliness": 2.7,
    "total": 28.9,
    "totalPercentage": 0.4817
  },
  {
    "rank": 24,
    "iso": "TR",
    "country": "Türkiye",
    "publicAdoption": 3.3,
    "infrastructureAdoption": 7.2,
    "innovationAndTechnology": 8,
    "regulatoryEnvironment": 2.8,
    "economicFactors": 5.4,
    "taxFriendliness": 0.8,
    "total": 27.5,
    "totalPercentage": 0.4583
  },
  {
    "rank": 25,
    "iso": "ME",
    "country": "Montenegro",
    "publicAdoption": 0.9,
    "infrastructureAdoption": 3.8,
    "innovationAndTechnology": 3.3,
    "regulatoryEnvironment": 5.3,
    "economicFactors": 6.1,
    "taxFriendliness": 6.2,
    "total": 25.6,
    "totalPercentage": 0.4267
  },
  {
    "rank": 26,
    "iso": "NA",
    "country": "Namibia",
    "publicAdoption": 3.5,
    "infrastructureAdoption": 3.5,
    "innovationAndTechnology": 0,
    "regulatoryEnvironment": 4.3,
    "economicFactors": 5.2,
    "taxFriendliness": 8.3,
    "total": 24.8,
    "totalPercentage": 0.4133
  }
];
export {cryptoAdoptionIndexData};